import { Container, Row, Col } from "react-bootstrap";
import "../Styles/TopDeals.css";
import { FaFacebookF, FaInstagram, FaYoutube, FaHeadphones } from "react-icons/fa";


const MediaLinks = ({ user }) => (
  <div className="container py-5">
    <h1>About Us</h1>
    <p>We are a passionate team behind Mati Haat, committed to promoting a green lifestyle and providing high-quality agricultural inputs and outputs. Our mission is to empower gardeners and farmers with organic and sustainable solutions.</p>
      <footer style={{ backgroundColor: "#f9f9f9", color: "#2b2b2b", padding: "40px 0" }}>
      <Container>
        <Row className="text-center text-md-start">
          {/* Left Column */}
          <Col md={4} className="mb-4 mb-md-0">
            <img
              src="https://matifoods.in/wp-content/uploads/2022/04/Mati-Haat-Web-Logo-2.png"
              alt="Mati Haat"
              style={{ width: "130px", marginBottom: "20px" }}
            />
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <FaHeadphones style={{ color: "#8BC34A", fontSize: "30px", marginRight: "10px" }} />
              <div>
                <p className="mb-0">Got Questions? Call us 24/7!</p>
                <strong>+91 9654870373</strong>
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-center justify-content-md-start gap-3">
              <a href="https://www.facebook.com/profile.php?id=61550736893804" style={{ color: "#000" }} className=" fs-5" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.instagram.com/matihaat/" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.youtube.com/@FarmingwithMatihaat" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
          </Col>

          {/* Middle Column - Quick Links */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5 style={{ color: "#7BA127" }}>Quick Links</h5>
            <ul className="list-unstyled">
              <ul className="list-unstyled">
                <li><a href="/about-us" style={{ color: "#000" }} className="text-decoration-none">About Us</a></li>
                <li><a href="/contact-us" style={{ color: "#000" }} className="text-decoration-none">Reach Us</a></li>
               
                
                
                <li><a href="/track-order" style={{ color: "#000" }} className="text-decoration-none">Track your Order</a></li>
              </ul>
            </ul>
          </Col>

          {/* Right Column - Customer Care */}
          <Col md={4}>
            <h5 style={{ color: "#7BA127" }}>Customer Care</h5>
            <ul className="list-unstyled">
              <li><a href="/privacy-policy" style={{ color: "#000" }} className="text-decoration-none">Privacy Policy</a></li>
              <li><a href="/shipping-policy" style={{ color: "#000" }} className="text-decoration-none">Shipping Policy</a></li>
              <li><a href="/refund-policy" style={{ color: "#000" }} className="text-decoration-none">Refund and Returns Policy</a></li>
              <li><a href="/payment-methods" style={{ color: "#000" }} className="text-decoration-none">Payment Methods</a></li>
              <li><a href="/terms-and-conditions" style={{ color: "#000" }} className="text-decoration-none">Terms and Conditions</a></li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  </div>

  
);

export default MediaLinks;